/**
 * Style constants for the HBFilters component.
 * These constants are used to maintain consistency across the component and prevent magic numbers.
 */

const POPOVER_PADDING = 12;
const POPOVER_MARGIN = 4;
const TOTAL_PADDING = POPOVER_PADDING + POPOVER_MARGIN;

export const STRUCTURE = {
    itemMargin: `${POPOVER_MARGIN}px`,
    popoverPadding: `${POPOVER_PADDING}px`,
    gapBetweenChips: '8px',
    gapBetweenChipsAndClear: '32px',
    barHeight: '24px',
    maxPopoverHeight: '335px',
    popoverWidth: '250px',
    popoverHeaderHeight: '18px',
    headerPadding: `${POPOVER_PADDING}px 6px 4px ${TOTAL_PADDING}px`,
    gapBetweenChipAndPopover: 4,
    gapBetweenFilterChips: '8px'
};
